import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";

import useGetUserProperties from "@/users/v3/useGetUserProperties";
import contentPreviewSettings from "@/view/constants/contentPreviewSettings/contentPreviewSettings.constants";

const useBannerMode = (props?: {
  setters?: Array<(value: boolean) => unknown>;
}) => {
  const setters = props?.setters ?? [];
  const router = useRouter();
  const { query } = router;
  const previewFor = `${query["preview_for"] ?? ""}`;

  const bannerRef = useRef<HTMLDivElement | null>(null);
  const [isBannerModeActive, setIsBannerModeActive] = useState(false);

  const isUeaApp =
    previewFor &&
    Object.keys(contentPreviewSettings.supportedValues).includes(previewFor);

  const { isStudent } = useGetUserProperties();
  const canUseBannerMode = !isStudent;

  useEffect(() => {
    if (isUeaApp) {
      setIsBannerModeActive(true);
    } else if (!canUseBannerMode) {
      setIsBannerModeActive(false);
    }

    // Scroll to banner when rendered and focus
    if (isBannerModeActive && bannerRef?.current) {
      bannerRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [isBannerModeActive]);

  const handleToggleBannerMode = () => {
    // Disable states when toggle action called.
    if (setters.length) {
      setters.forEach(function (setter) {
        setter(false);
      });
    }
    setIsBannerModeActive((bannerMode) => !bannerMode);
  };

  const toggleBannerMode = handleToggleBannerMode;

  return {
    canUseBannerMode,
    isBannerModeActive,
    bannerRef,
    toggleBannerMode,
  };
};

export default useBannerMode;
